export default "__VITE_ASSET__D_hmxga2__";